import { useContext } from "react"

import { TraceabilityOperationsContext } from "~/pages/SupplierPortal/TraceabilityRequests/context/TraceabilityOperationsContext"

export const useTraceabilityOperations = () => {
  const context = useContext(TraceabilityOperationsContext)
  if (!context) {
    throw new Error(
      "useTraceabilityOperations must be used within a TraceabilityOperationsProvider"
    )
  }
  return context
}
